import axios from '@/plugins/http'

export const getSubscription = (storeSlug) => (
  axios.get(`/api/v1/stores/${storeSlug}/subscriptions`)
)

export const updateSubscription = (storeSlug, data) => (
  axios.put(`/api/v1/stores/${storeSlug}/subscriptions`, data)
)
